import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface ConfirmDialogProps {
  open: boolean
  title: string
  body: string
  confirmLabel: string
  pending?: boolean
  error?: string | null
  destructive?: boolean
  onConfirm: () => void
  onOpenChange: (open: boolean) => void
}

/** In-app confirmation (never `window.confirm`). */
export function ConfirmDialog({ open, title, body, confirmLabel, pending, error, destructive, onConfirm, onOpenChange }: ConfirmDialogProps) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{body}</DialogDescription>
        </DialogHeader>
        {error ? (
          <p role="alert" className="rounded-md bg-status-escalated-bg px-3 py-2 text-meta text-status-escalated-fg">
            {error}
          </p>
        ) : null}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={pending}>
            {t('common.cancel')}
          </Button>
          <Button variant={destructive ? 'destructive' : 'default'} onClick={onConfirm} disabled={pending}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
